export default "__VITE_ASSET__C$qMNNQR__"